<template>
  <div class="template">
    <div v-if="!selectedTemplate" class="no template-card">
      <span>Please select a template</span>
    </div>
    <div v-if="!!selectedTemplate" class="template-info-container">
      <object-main-info :fields="fields" :identifier="template.name ? template.name : ''" :identifier-label="$tc('Label', 1)"
        :editing-data="editingData"
        :show-edit-button="actionToExecute !== 'addTemplate' && userHasPermission('user_update')"
        :card-label="cardLabel" :height="editingData ? '33%' : '18%'" :submit-button-label="submitButtonLabel"
        :required-fields-filled="requiredFieldsAreFilled" @toggle-edit="toggleEdit" @update-object="updateTemplate"
        @save-object="saveObject" @cancel-edit="discardChangesDialogIsOpen = true">

        <template v-slot:buttons-before-edit-slot>
          <custom-button v-if="actionToExecute !== 'addTemplate'" :icon="'delete'" :icon-size="13" :height="'20px'"
            :width="'20px'" :button-styling="buttonStyling" @buttonClick="deleteDialogIsOpen = true" />
        </template>

      </object-main-info>

      <import-specific-info :fields="template.fields" :valueOptions="templatesByTypeOptions" :key="updateSpecificInfoKey" :editing-data="editingData"
        :required-fields-filled="requiredFieldsAreFilled" :submit-button-label="submitButtonLabel" :layerSelected="template.layer"
        @cancel-edit="discardChangesDialogIsOpen = true" @save-template="saveChangesDialogIsOpen = true" />
    </div>
    <loading-spinner :active.sync="loading" :is-full-page="false" color="var(--app-primary-base)" style="position: absolute;" />
    <dialog-choice :isOpen="saveChangesDialogIsOpen" :title="$t('SaveChanges')" :content="$t('SaveChangesContent')"
      :mainActionLabel="$t('Confirm')" @mainAction="saveObject" :secondaryActionLabel="$t('Cancel')"
      @secondaryAction="saveChangesDialogIsOpen = false" icon="mdi-content-save" iconColor="var(--app-primary-base)" />
    <dialog-choice :isOpen="discardChangesDialogIsOpen" :title="$t('DiscardChanges')"
      :content="$t('ClusterCreationConfirmation')" :mainActionLabel="$t('Confirm')" @mainAction="cancelEdit"
      :secondaryActionLabel="$t('Cancel')" @secondaryAction="discardChangesDialogIsOpen = false" icon="mdi-delete"
      iconColor="var(--app-primary-base)" />
    <dialog-choice
      :isOpen="deleteDialogIsOpen"
      :title="$t('DeleteTemplate')"
      :content="$t('TemplateDeletionConfirmation')"
      :mainActionLabel="$t('Delete')"
      @mainAction="deleteTemplate"
      :secondaryActionLabel="$t('Cancel')"
      @secondaryAction="deleteDialogIsOpen = false"
      icon="mdi-delete"
      iconColor="var(--app-primary-base)"
    />
  </div>
</template>

<script>

import { mapActions } from 'vuex';
import { bus } from "@/main.js";
import _ from 'lodash';
import utils from "@/utils";
import { checkPermissionsMixin } from "@/mixins/checkPermissionsMixin";
import { objectManagementMixin } from "@/mixins/objectManagementMixin";
import { createEditPageMixin } from "@/mixins/management/createEditPageMixin";
import LoadingSpinner from "vue-loading-overlay";
import ObjectMainInfo from '@/newComponents/_Organisms/ObjectMainInfo';
import ImportSpecificInfo from '@/newComponents/WorkspaceManagement/Templates/ImportSpecificInfo.vue';
import DialogChoice from '@/newComponents/_Molecules/DialogChoice.vue';
import CustomButton from '@/newComponents/_Atoms/CustomButton'

export default {
  name: "Import",

  components: {
    ImportSpecificInfo,
    LoadingSpinner,
    DialogChoice,
    ObjectMainInfo,
    CustomButton,
  },

  mixins: [checkPermissionsMixin, objectManagementMixin, createEditPageMixin],

  props: {
    selectedTemplate: {
      type: Object,
    },
  },

  data() {
    return {
      loading: false,
      template: {
        blocked: false,
        id: null,
        layer: null,
        name: null,
        template_type_id: null,
        copy_from_template_id: null,
        fields: [],
      },
      copyOptions: {},
      deleteDialogIsOpen: false,
      editingData: false,
      originalTemplate: {},
      updateSpecificInfoKey: 1,
      dataToSend: {},
      actionToExecute: 'update_selected_template',
      submitButtonLabel: 'Save',
      cardLabel: 'Edit Template',
      options: [],
      list_name: 'list_template_type',
      templatesByTypeOptions: null,
      saveChangesDialogIsOpen: false,
      discardChangesDialogIsOpen: false,
      allTemplates: [],
      layerOptions:[],
      buttonStyling: {
        'padding': '0px',
        'drop-shadow': '0.85px 0.85px 1.75px rgba(0, 0, 0, 0.25)',
        'border-radius': '4px',
      },
    }
  },

  created(){
    if (this.$store.getters.getAllObjectTypesProperties.length === 0) {
      this.FETCH_ALL_OBJECTS_PROPERTIES_WITHOUT_FIELDS();
    }

    bus.$on("all-templates", templates => {
      this.allTemplates = templates;
    })
  },

  mounted() {
    this.loadLayerOptions();
    //this.loadFieldOptions();
  },

  destroyed() {
    bus.$off("all-templates");
  },

  watch: {

    "template.template_type_id"(type) {
      if (!type) {
        this.template.layer = null;
        this.template.type = null;
        this.template.fields = [];
        this.template.copy_from_template_id = null;
        this.copyOptions = null;
        return;
      }
      let layer = this.layerOptions.find(
        layer => layer.id === type
      );
      this.template.layer = layer.name;
      let copyfrom = this.allTemplates.filter(
        template => template.template_type_id === type
      );
      this.templatesByTypeOptions = copyfrom
    },

    "template.copy_from_template_id"(id) {
      if (this.template.copy_from_template_id != null) {
        this.getCreateTemplateById();
        let filter = this.templatesByTypeOptions.find(
          template => template.id === id
        );
        this.template.fields = filter.fields;
        //Need to force vue update
        this.updateSpecificInfoKey = ++this.updateSpecificInfoKey ;
      }
    },

    "template.layer"(newValue) {
      if(!newValue){
        this.template = {
          ...this.template,
          blocked: false,
          id: null,
          layer: null,
          template_type_id: null,
          copy_from_template_id: null,
          fields: [],
        };

        this.updateSpecificInfoKey = ++this.updateSpecificInfoKey ;
      }
      if(!!newValue){
        this.getCopyFrom();
        //this.loadFieldOptions();
      }
    },

    selectedTemplate(value) {
      if (value !== null && Object.keys(value).length === 0) { //if template is an empty object for creation
        this.setCreateTemplateVariables();
      } else if (!!value) { // if the template is a normal object to be edited
        this.setEditTemplateVariables();
      } else if (value === null) { // if there is no object
        this.clearVariables();
      }
    },

    editingData() {
      bus.$emit("toggle-create-edit-flag")
    },
  },

  computed: {
    requiredFieldsAreFilled() {
      return this.template ? !!this.template.name && !!this.template.layer : false;
    },


    creatingTemplate() {
      return this.actionToExecute === 'addTemplate';
    },

    normalizedLayerOptions(){
      let normalizedLayerOptions = [];
        this.layerOptions.forEach(type => {
          normalizedLayerOptions.push({code: type.id, name:  this.getPossibleLayers(type.name)})
        });
        return normalizedLayerOptions
    },

    fields() {
      let fields = [];
      if (this.template !== null) {
        fields = [
          {
            icon: "layers",
            label: this.$i18n.tc("Layer", 1),
            value: !this.editingData
              ? this.parseSelectValue([this.template.template_type_id], this.normalizedLayerOptions)
              : this.template.template_type_id,
            size: '100%',
            varName: 'template_type_id',
            inputType: 'select',
            options: this.normalizedLayerOptions,
            disabled: false,
            required: true,
            min: 4,
            max: 20,
          },
          {
            icon: "assignment_turned_in",
            label: this.$i18n.tc("Blocked", 1),
            value: this.editingData
              ? this.template.blocked ? 'True' : 'False'
              : this.template.blocked ? this.$i18n.t('Yes') : this.$i18n.t('No'),
            size: '100%',
            disabled: false,
            required: true,
            inputType: 'radio',
            radioOptions: [{ value: 'True', label: this.$i18n.t('Yes') }, { value: 'False', label: this.$i18n.t('No') }],
            varName: 'blocked',
            size: this.editingData ? '33%' : '100%',
          },
        ];

        if (this.editingData && this.actionToExecute === "addTemplate") {
          fields.splice(0, 0, {
            label: this.$i18n.tc("Label", 1),
            value: this.template.name,
            disabled: false,
            required: true,
            inputType: 'text',
            varName: 'name',
            size: '100%',
          },
          );
          fields.splice(2, 0, {
            label: this.$i18n.tc("Copy From", 1),
            value: !this.editingData
              ? this.parseSelectValue([this.template.copy_from_template_id], this.copyOptions)
              : this.template.copy_from_template_id,
            options: this.copyOptions,
            disabled: this.template.template_type_id ? false : true,
            required: false,
            inputType: 'select',
            varName: 'copy_from_template_id',
            size: '100%',
          },
          );
        }
         else if(this.editingData){
          fields.splice(0, 0, {
            icon: "person",
            label: this.$i18n.tc("Label", 1),
            value: this.template.name,
            disabled: false,
            required: true,
            inputType: 'text',
            varName: 'name',
            size: '100%',
          },
          );
        }
      }
      return fields;
    },

  },

  methods: {
    ...mapActions([
      "fetchTemplateByID",
      "GET_LIST",
      "fetchImportTemplates",
      "editImportTemplateById",
      "addImportTemplate",
      "fetchTemplatesTypes",
      "FETCH_ALL_OBJECTS_PROPERTIES_WITHOUT_FIELDS",
      "FETCH_OBJECT_FORM_STRUCTURE_BY_OBJECT_TYPE",
      "deleteImportTemplate",
    ]),

    normalizedCopyFromOptions(templatesByTypeOptions){
      if (templatesByTypeOptions) {
        let normalizedCopyFromOptions = [];
        templatesByTypeOptions.forEach(type => {
          normalizedCopyFromOptions.push({code: type.id, name: this.getPossibleLayers(type.name)})
        });
        this.copyOptions = normalizedCopyFromOptions;
      }else{
        return [];
      }
    },

    async getCopyFrom() {

        let queryParams = {
          paginate: false,
          "filter[layer]": this.template.layer
        };

        let fetch = await this.fetchImportTemplates(queryParams);
        this.normalizedCopyFromOptions(fetch.data);
    },

    requiredFieldsValidation() {
      return true;
    },

    async getUserTypeList() {
      this.options = await this.GET_LIST({
        listName: this.list_name
      });
    },

    async getTemplateById() {
      let id = this.selectedTemplate.id;
      try {
        this.template = await this.fetchTemplateByID({
          id: id,
          append: ["fields", "type"]
        });

        if (this.template.type && this.template.type.length > 0) {
          this.template.layer = this.template.type[0].name;
        }

        this.originalTemplate = _.cloneDeep(this.template);
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },

    async getCreateTemplateById() {
      let id = this.template.copy_from_template_id;
      try {
        let fetchTemplate = await this.fetchTemplateByID({
          id: id,
          append: ["fields", "type"]
        });

        this.template.fields = fetchTemplate.fields;

        this.template.type = fetchTemplate.type;

        if (this.template.type && this.template.type.length > 0) {
          this.template.layer = this.template.type[0].name;
        }

      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },

    async loadFieldOptions() {
      try {
        if (
          this.template.layer &&
          this.template.layer !== "fc_building_mass_update"
        ) {
          let formFields = await this.FETCH_OBJECT_FORM_STRUCTURE_BY_OBJECT_TYPE(
            {
              layer: this.template.layer,
              needsTabs: false,
              needsFields: true
            }
          );
          this.templatesByTypeOptions = [...formFields.fields]
          this.template.fields = formFields.fields
          .filter(field => field.required === true)
          .map(field => ({
            ...field,
            value: field.var_name
          }));
        }
      } catch (e) {
        console.log(e);
      } finally {
        this.loading = false;
      }
    },

    async deleteTemplate(){
      try {
        this.loading = true;
        await this.deleteImportTemplate(this.template.id);
        } catch (e) {
          console.log(e);
        } finally {
          bus.$emit('reload-templates');
          this.$emit('clear-selected-item');
          this.deleteDialogIsOpen = false
          this.loading = false;
      }
    },

    async loadLayerOptions() {
      try {
        this.layerOptions = await this.fetchTemplatesTypes();
      } catch (e) {
        console.error(e);
      }
    },

    getPossibleLayers(layer) {
      if (layer) {
        let translation = this.$store.getters.getLayerTranslationKey(layer);
        return this.$i18n.tc(translation, 2);
      } else {
        return null;
      }
    },

    getIncludes() {
      let includes = "";
      includes += "company,";
      includes += "permissions,";
      includes += "roles,";
      includes += "workspaces";
      return includes;
    },

    cancelEdit() {
      this.discardChangesDialogIsOpen = false;
      this.editingData = false;
      if (this.template.id) {
        this.template = _.cloneDeep(this.originalTemplate);
      } else {
        this.$emit('clear-selected-item');
      }
    },

    toggleEdit() {
      if (this.editingData) {
        this.discardChangesDialogIsOpen = true;
      } else {
        this.editingData = !this.editingData
      }
    },

    updateTemplate(updatedValue) {
      this.template[updatedValue.varName] = updatedValue.value;
    },

    prepareDataToSendFields() {
      let dataToSend = { ...this.template };
      let fields = this.template.fields;
      delete dataToSend.fields;

      dataToSend.field_values = fields;

      return dataToSend;
    },

    async saveObject() {
      this.saveChangesDialogIsOpen = false;
      try {
        for(const field of this.template.fields){
          if(!field.key){
            this.$toasted.global.toast_error(this.$i18n.t('KeyRequired'));
            return;
          }
        }
        this.loading = true;

        this.createDataToSend();
        delete this.dataToSend.type;
        if (Object.keys(this.dataToSend).length > 0) {
          if (!this.creatingTemplate) {
            this.dataToSend.uuid = this.template.uuid;
            try {
              await this.editImportTemplateById({
                id: this.template.id,
                data: this.dataToSend
              });
            } catch (error) {
                console.error(error);
                this.handleError(error);
            }
          } else{
            try {
              let dataToSend = this.prepareDataToSendFields();

              await this.addImportTemplate(dataToSend);

              if (!this.creatingTemplate) {
                this.getTemplateById();
                this.$toasted.global.toast_success(this.$i18n.t('TemplateUpdatedSuccessfully'));
              } else {
                this.$toasted.global.toast_success(this.$i18n.t('TemplateCreatedSuccessfully'));
              }
            } catch (error) {
                console.error(error);
                this.handleError(error);
            }
          }
        }

        this.editingData = false;


        bus.$emit('reload-templates');
      } catch (error) {
        console.error(error);
        this.handleError(error);
      } finally {
        this.loading = false;
        this.dataToSend = {};
      }
    },

    valuesAreDifferent(value1, value2) {
      if (typeof value1 !== typeof value2) {
        return true;
      }

      if (typeof value1 === 'object' && value1 !== null && value2 !== null) {
        return JSON.stringify(value1) !== JSON.stringify(value2);
      }

      return value1 !== value2;
    },

    createDataToSend() {
      Object.keys(this.template).forEach(key => {
        if (this.template[key] !== this.originalTemplate[key]) {
          this.dataToSend[key] = this.template[key];
        }
      });
      if (!this.creatingTemplate) {

        this.dataToSend.fields = {};

        Object.keys(this.template.fields).forEach(key => {
            this.dataToSend.fields[key] = this.template.fields[key];
            delete this.dataToSend.fields[key].originalData;
            delete this.dataToSend.fields[key].editable;
        });

        if (Object.keys(this.dataToSend.fields).length === 0) {
          delete this.dataToSend.fields;
        }
      }
      //BE needs field_values but sends fields
      this.dataToSend.field_values = this.dataToSend.fields;
      delete this.dataToSend.fields;

    },

  handleError(error) {
    let errorHandle = utils.errorHandler(error);

    if (typeof errorHandle === "object") {
      if (errorHandle.hasOwnProperty("username")) {
        if (errorHandle.username[0].includes('regex')) {
          this.$toasted.global.toast_error(this.$i18n.t('UserRegex'));
        }
        if (errorHandle.username[0].includes('unique')) {
          this.$toasted.global.toast_error(this.$i18n.t('UserUnique'));
        }
      }
      if (errorHandle.hasOwnProperty("email")) {
        this.$toasted.global.toast_error(this.$i18n.t('ValidEmail'));
      }
      if (errorHandle.hasOwnProperty("password")) {
        this.$toasted.global.toast_error(this.$i18n.t('ValidPassword'));
      }
      if (errorHandle.hasOwnProperty("name")) {
        this.$toasted.global.toast_error(this.$i18n.t('ValidName'));
      }
    } else if (typeof errorHandle === "string") {
      this.$toasted.global.toast_error(errorHandle);
    }
  },

  setCreateTemplateVariables() {
    this.template = {
      ...this.template,
      blocked: false,
      id: null,
      layer: null,
      name: null,
      template_type_id: null,
      copy_from_template_id: null,
      fields: [],
    };
    this.originalTemplate = {},
    this.actionToExecute = 'addTemplate';
    this.submitButtonLabel = 'Create';
    this.cardLabel = 'New Template';
    this.editingData = true;
  },

  setEditTemplateVariables() {
    this.getTemplateById();
    this.actionToExecute = 'editTemplateByID';
    this.submitButtonLabel = 'Save';
    this.cardLabel = 'Edit Template';
  },

  clearVariables() {
    this.template = null;
    this.originalTemplate = null;
    this.editingData = false;
  },
}
}
</script>

<style scoped>
.template {
  height: 100%;
  max-height: 100%;
  background-color: #fff;
  position: relative;
  border-radius: 8px;
}

.template-card {
  height: 100%;
}

.template-card {
  box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.25);
  border-radius: 8px;
}

.no.template-card {
  display: flex;
  flex-direction: column;
  align-content: center;
  justify-content: center;
}

.no.template-card>span {
  color: var(--app-primary-base);
  text-align: center;
  font-size: 12px;
  font-weight: 600;
  line-height: normal;
}

.template-info-container {
  gap: 8px;
  display: flex;
  flex-direction: column;
  max-height: 100%;
  height: 100%;
}

.template-logo {
  background-color: white;
  border-radius: 8px;
  height: 40px;
  width: 40px;
  box-shadow: 1.75px 1.75px 4.75px 0px rgba(0, 0, 0, 0.25);
  margin-right: 16px;
  margin-left: 2px;
}

.edit-image-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 10px 0;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/newComponents/WorkspaceManagement/Templates/Import.vue